import EnquiryService from '@/services/enquiry.service';
import LeadEventService from "@/services/lead-event.service";
import Vue from 'vue';

export const leadEvent = {
  namespaced: true,
  state: {
    leadEvents: [],
    enquiries: [],
    quotes: [],
  },
  actions: {
    getSingle({ commit, dispatch }, id) {
      return LeadEventService.getLeadEventData(id)
        .then((leadEvent) => {
          leadEvent = leadEvent.data;
          commit('updateSingleLeadEvent', leadEvent);
        })
        .catch((error) => {
          dispatch('alert/error', error, { root: true });
        });
    },
    getEnquiries({ commit }, leadEventId) {
      return EnquiryService.getEnquiriesByLeadEventId(leadEventId)
        .then((enquiries) => {
          enquiries = enquiries.data;
          commit('updateLeadEnquiries', { leadEventId, enquiries });
        })
        .catch((error) => {
          dispatch('alert/error', error, { root: true });
        });
    },
    updateDealStage({ commit }, data) {
      const leadEventId = data.leadEventId;
      const dealStageId = data.dealStageId;
      return LeadEventService.updateDealStage(leadEventId, dealStageId)
        .then((res) => {
          return res;
        })
        .catch((error) => {
          dispatch('alert/error', error, { root: true });
        });
    },
    getQuotes({ commit, dispatch }, leadEventId) {
      return LeadEventService.getQuotes(leadEventId)
        .then((quotes) => {
          quotes = quotes.data;
          commit('updateLeadEventQuotes', { leadEventId, quotes });
          return quotes;
        })
        .catch((error) => {
          dispatch('alert/error', error, { root: true });
        });
    },
    createQuote({ commit, dispatch }, { leadEventId, formData }) {
      return LeadEventService.createQuote(leadEventId, formData)
        .then((result) => {
          // Reload quotes after creation
          return result;
        })
        .catch((error) => {
          dispatch('alert/error', error, { root: true });
        });
    },
    updateQuote({ commit, dispatch }, { leadEventId, quoteId, data }) {
      return LeadEventService.updateQuote(leadEventId, quoteId, data)
        .then((result) => {
          // Reload quotes after update
          return result;
        })
        .catch((error) => {
          dispatch('alert/error', error, { root: true });
        });
    },
  },
  mutations: {
    updateSingleLeadEvent(state, leadEvent) {
      state.leadEvents = state.leadEvents.filter(function(item) {
        return parseInt(item.id) !== parseInt(leadEvent.id);
      });
      state.leadEvents.push(leadEvent);
    },
    updateLeadEnquiries(state, { leadEventId, enquiries }) {
      Vue.set(state.enquiries, leadEventId, enquiries);
    },
    updateLeadEventQuotes(state, { leadEventId, quotes }) {
      Vue.set(state.quotes, leadEventId, quotes);
    },
  },
  getters: {
    getLeadEventsById: (state) => (id) => {
      let leadEvent = state.leadEvents.find((leadEvent) => parseInt(leadEvent.id) === parseInt(id));
      return leadEvent || {};
    },
    getEnquiriesByLeadEventId: (state) => (leadEventId) => {
      return state.enquiries[leadEventId] || [];
    },
    getQuotesByLeadEventId: (state) => (leadEventId) => {
      return state.quotes[leadEventId] || null;
    },
  },
};
